<template>
    <div class="no-data" :style="borderStyle">
        <img class="icon" :src="noDataImg" />
        <p class="desc">{{ tips }}</p>
    </div>
</template>

<script>
import noDataImg from '@/assets/image/no-data.png';

export default {
    name: 'CM_Empty',
    props: {
        tips: {
            type: String,
            required: true,
            default: '没有数据哦~'
        },
        border: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            noDataImg,
            borderStyle: {
                border: this.border ? '1px solid rgba(220, 223, 230, 1)' : '0'
            }
        };
    }
};
</script>

<style lang="less" scoped>
.no-data {
    padding: 32px 0 60px 0;
    border-radius: 4px;
    border: 1px solid rgba(220, 223, 230, 1);
    text-align: center;
    .icon {
        width: 200px;
    }
    .desc {
        font-size: 16px;
        color: #666;
        padding-bottom: 30px;
    }
}
</style>
